import { createAction } from '@reduxjs/toolkit';

import { RemoveSubSuggestionPayload } from './types';

export const removeSubSuggestion = createAction<RemoveSubSuggestionPayload>(
  'tester/removeSubSuggestion'
);
